import React, { useEffect, useState } from "react";
import styles from './style.module.scss'
import Button from "components/atoms/Button/Button";
import InputField from "components/atoms/InputField/InputField";
import Loading from "components/atoms/Loading/Loading";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { toast } from "react-toastify";
import { getSingleDataWithPhone, resetSearchData } from "store/slices/data.slice";

const LeadFormPhone:React.FC = () => {
    const [phoneNumber, setPhoneNumber] = useState<number>()
    const { isLoading } = useAppSelector((state) => state.data.searchData);
    const dispatch = useAppDispatch();

    const save = (data: { phoneNumber: number }) => {
      dispatch(getSingleDataWithPhone(data));
    };
  
    const handleSave = (e: any) => {
      e.preventDefault();
      const valid =
      /^\d{10}$/;
      if (!phoneNumber) {
        return toast.error("Please fill phone number");
      } else if (!valid.test(String(phoneNumber))) {
        return toast.error("Please fill a valid number");
      }
      save({ phoneNumber: Number(phoneNumber) });
    };

    useEffect(() => {
      return () => {
        dispatch(resetSearchData());
      };
    }, []);
    
    return <form className={styles.form_oneinput}>
      <InputField
        iconName="phone"
        className="sm:w-auto w-full"
        type="number"
        width="auto"
        size="small"
        disabled={isLoading}
        onChange={(e: any) => setPhoneNumber(e.target.value)}
        placeholder="Enter a Phone Number"
      />
      {isLoading 
        ? <div className="flex items-center gap-3">
          <Loading height="38px" spinnerSize={25} />
          <p>Searching...</p>
        </div>
        : <Button
          className="w-full sm:w-max"
          iconName="search" size="sm"
          onClick={(e: any) => handleSave(e)}
        >Single Search</Button>
      }</form>
}

export default LeadFormPhone